import { RefreshCw } from "lucide-react";
import { useHistory } from "react-router-dom";

import { Filter } from "../../../../components/ui/Filter";
import { PeriodFilter } from "../../../../components/ui/Form/PeriodFilter";
import { CrmPetDiagnosisController } from "../../../../services/controllers/crmPetDiagnosis";
import { CRM_PET_DIAGNOSIS_TABS, useCrmPetDiagnosis } from "../../../../store/crmPetDiagnosis/useCrmPetDiagnosis";
import { PERIOD_OPTIONS } from "../constants";

export function ActivityFilter() {
  const controller = CrmPetDiagnosisController();
  const history = useHistory();
  const filters = useCrmPetDiagnosis((state) => state.data.filters.activity);
  const loading = useCrmPetDiagnosis((state) => state.data.loading.usage);

  return (
    <Filter.Root
      onSubmit={(event) =>
        controller.applyFilters(CRM_PET_DIAGNOSIS_TABS.activity, event, history)
      }
    >
      <Filter.Container>
        <PeriodFilter
          withPeriod
          period={filters.period}
          dateFrom={filters.from}
          dateTo={filters.to}
          options={PERIOD_OPTIONS}
          onPeriodChange={(period) => {
            controller.setPeriod(CRM_PET_DIAGNOSIS_TABS.activity, period);
            if (period !== "custom") {
              controller.applyFilters(CRM_PET_DIAGNOSIS_TABS.activity, null, history);
            }
          }}
          onDateChange={(field, value) =>
            controller.setDate(CRM_PET_DIAGNOSIS_TABS.activity, field, value)
          }
        />
      </Filter.Container>
      <Filter.Actions>
        <Filter.Action isLoading={loading}>
          <Filter.ActionIcon icon={RefreshCw} isLoading={loading} />
          Atualizar atividade
        </Filter.Action>
      </Filter.Actions>
    </Filter.Root>
  );
}
